export default "__VITE_ASSET__Biu5PTWK__"